import { logWarning } from "@faire/web--source/common/logging";
import debounce from "lodash/debounce";

import { getBrandToken } from "./getBrand";
import { getRetailerToken } from "./getRetailer";

export const getRetailerOrBrandToken = (): string => {
  const token = getRetailerToken() || getBrandToken();
  if (!token) {
    debounce(logMissingToken, 1000)();
    return "";
  }
  return token;
};

const logMissingToken = () => {
  logWarning("There's not a retailer or brand token in the session");
};
